import { Box, Stack, Typography, IconButton, Dialog, TextField } from "@mui/material";
import { DeleteForever, Edit } from "@mui/icons-material";
import React, { useState } from "react";
import { useEffect } from "react";
import BilletEditForm from "../forms/billetEdit";

export default function BilletInfoSection({ billet, rmBillet, setBillet, events, index }) {
    const [event , setEvent] = useState(null);
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        if (billet?.event) {
            if ( events.some(e=>e._id === billet.event) ) {
                setEvent(events.find(e=>e._id === billet.event));
            } else {
                fetch(`${process.env.REACT_APP_API_URL}/public/event/${billet.event}`)
                .then(response => {
                    const token = response.headers.get('x-auth-token');
                    if (token) localStorage.setItem('token', token);
                    return response.json()
                })
                .then(data => setEvent(data))
                .catch(error => console.error('Error fetching event:', error));
            }
        }
    }, [billet]);

    useEffect(()=> {
        if(!(!!billet.owner.nom && !!billet.owner.prenom)) {
            setEditing(true)
        }
    }, [billet?.owner])

    return <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, py: 2, px:{xs: 1, sm: 2}}}>
        <Stack direction="row" spacing={4} alignItems="center" justifyContent={'space-between'}>
            <Stack direction="row" spacing={{xs: 1, sm: 2}} alignItems="center">
                <IconButton onClick={rmBillet} sx={{color:'alerte.main'}}>
                    <DeleteForever />
                </IconButton>
                <Box>
                    {!!event && !!billet.num ? <Typography variant="h6" textTransform='capitalize'>{event?.titre} - {billet?.tarif}</Typography>
                    :<TextField select label="Événement" color='focus' value={billet.event} required size='small' slotProps={{select: {native: true}, inputLabel: {shrink: true}}}
                    sx={{minWidth: '250px', width: '80%'}} onChange={(e) => setBillet({...billet, event: e.target.value})}>
                        <option value="" disabled={true}>Sélectionner un événement</option>
                        {events.map((event) => (
                            <option key={event._id} value={event._id}>{event.titre}</option>
                        ))}
                    </TextField>}

                    <Stack direction="row" spacing={1} alignItems='center' mt={1}>
                        <Typography variant="body1" fontSize={14} sx={{whiteSpace: 'nowrap'}}>billet au nom de {!editing && <span style={{textTransform:'capitalize'}}>{billet.owner?.nom+' '+billet.owner?.prenom}</span>}</Typography>
                        {!editing && <IconButton onClick={() => setEditing(true)}><Edit sx={{fontSize: 14}}/></IconButton>}
                        {editing && <TextField required placeholder="nom" value={billet.owner?.nom} onChange={(e) => setBillet({...billet, owner: {...billet.owner, nom: e.target.value}})} size='small' 
                        variant='filled' fullWidth sx={{minWidth: '100px', '& .MuiFilledInput-input': {py: 0.5}}} slotProps={{input: {style: {borderRadius: 0, height: '30px', fontSize:16}}}} />}
                        {editing && <TextField required placeholder="prénom" value={billet.owner?.prenom} onChange={(e) => setBillet({...billet, owner: {...billet.owner, prenom: e.target.value}})} size='small' 
                        variant='filled' fullWidth sx={{minWidth: '100px', '& .MuiFilledInput-input': {py: 0.5}}} slotProps={{input: {style: {borderRadius: 0, height: '30px', fontSize:16}}}} />}
                    </Stack>
                </Box>
            </Stack>

            {!!event && <TextField select label="Tarif" color='focus' value={billet.tarif} required size='small' slotProps={{select: {native: true}, inputLabel: {shrink: true}}}
            sx={{minWidth: '250px', width:'30%'}} fullWidth onChange={(e) => setBillet({...billet, tarif: e.target.value, price: event.tarifs.find(t => t.nom === e.target.value)?.montant || 0})}>
                <option value="" disabled={true}>Sélectionner un tarif</option>
                <option value="Gratuit">Gratuit</option>
                <option value="Cadeau">Cadeau</option>
                {event.tarifs.map((tarif) => (
                    <option key={tarif._id} value={tarif.nom}>{tarif.nom+' - '+tarif.montant?.toFixed(2)} €</option>
                ))}
            </TextField>}

        </Stack>
    </Box>
}